export enum RECOMMENDED_SECTION_IDS {
  SLOT1 = 'slot_1',
  SLOT2 = 'slot_2',
  SLOT3 = 'slot_3',
  SLOT4 = 'slot_4',
}
